import React from "react";
import PulseLoader from "react-spinners/PulseLoader";

// Root Suspense fallback. Ships in the main bundle, so it cannot use
// AppLoadingSpinner / MainComponent.scss (both live in the lazy app chunk).
const style: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100vh",
  width: "100%"
};

const RootFallback = () => (
  <div style={style} aria-busy="true" aria-live="polite">
    <PulseLoader color="#888888" size={17} />
  </div>
);

export default RootFallback;
